import Router from "vue-router";
import VueRouter from "vue-router";
import Vue from "vue";
import auth from "./auth";
import home from "./home";
import other from "./other";
import contents from "@/router/contents";
import DoneView from "@/components/home/auth/DoneView.vue";
import ContactPage from "../components/home/ContactPage.vue"; 

Vue.use(Router);

const routes = [
    ...home,
    ...auth,
    ...other,
    ...contents,
    {
        path: "/done/:path?",
        name: "done",
        component: DoneView
    },
    { 
        path: "/contact",
        name: "Contact",
        component: ContactPage
    },
    {
        // Schedulerの更新画面URL（/scheduler/update/:scd_id）をMain.vueに紐付け
        path: "/scheduler/update/:scd_id",
        name: "SchedulerUpdate",
        component: () => import("@/components/scheduler/Main.vue"),
        props: true
    },
]

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

// 非ログイン時でも、アクセス許可するページをリストに入れるとアクセスできるように
const freeAccessList = [
    "/success-account", "/success-connect", "/failure-connect", "/plan", "/rules", "/privacy", "/transaction", "/done", "/contact", "/scheduler"
];


router.beforeEach((to, from, next) => {
    const localInfo = JSON.parse(localStorage.getItem("localInfo"));
    const uid = localInfo?.state?.user?.uid;

    document.querySelectorAll('.shepherd-element').forEach(el => el.remove());
    document.querySelectorAll('.shepherd-modal-overlay-container').forEach(el => el.remove());
  
    if (uid) {
      // ログイン済みでトップページなら強制リダイレクト
      if (to.path === "/") {
        next("/extract-histories");
      } else {
        next();
      }
    } else if (to.path === "/") {
      // 非ログインでもトップページはOK
      next();
    } else if (
      // `/scheduler/update/...` や `/done/xxx` も許可されるように startsWith に変更
      freeAccessList.some(free => to.path.startsWith(free))
    ) {
      next();
    } else {
      // next(false, "/") は無効（falseを渡すと第二引数は無視される）
      next("/");
      // location.reload(); ← reloadは不要（この1行でOK）
    }
});

export default router;
